// Valor inyectado al compilar (scripts/build.mjs). Las llaves secretas viven solo en el servidor de Cloudflare.
declare const __DEMO__: boolean

export const DEMO: boolean = typeof __DEMO__ !== 'undefined' ? __DEMO__ : false

/** Almacenamiento seguro: en algunos navegadores o vistas previas localStorage no está disponible */
const memory = new Map<string, string>()
export const storage = {
  get(k: string): string | null {
    try { return localStorage.getItem(k) } catch { return memory.get(k) ?? null }
  },
  set(k: string, v: string) {
    try { localStorage.setItem(k, v) } catch { memory.set(k, v) }
  },
  remove(k: string) {
    try { localStorage.removeItem(k) } catch { memory.delete(k) }
  },
}
